<template>
    <div>
        <button type="button" class="btn btn--primary btn--round owner__avatar-upload"
            @click.prevent="$refs.photo.click()">
            <i class="ri-edit-2-fill"></i>
        </button>
        <input ref="photo" class="d-none" type="file" name="file" @change="handleFileUpload($event)" />
    </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    props: {
        uploadToAccount: {
            type: Boolean,
            required: false,
            default: true,
        },
    },
    methods: {
        ...mapActions('user', ['uploadAvatar']),
        handleFileUpload(event) {
            const file = event.target.files[0];

            if (!file) {
                return;
            }

            if (!this.uploadToAccount) {
                this.$emit('fileUploaded', file);
                return;
            }

            const formData = new FormData();
            formData.append('file', file);

            this.uploadAvatar(formData)
                .then(() => {
                    window.showToastSuccess('Successfully uploaded.');
                })
                .catch((error) => {
                    if (error.response.status === 422 && error.response.data.errors) {
                        window.showToastError(Object.values(error.response.data.errors)[0][0]);
                    }
                });
        },
    },
};
</script>
